import { planTiers } from "@circle-react/helpers/planHelpers";

export const MINIMUM_REQUIRED_PLAN_TIER = planTiers.business;
